import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";

function beep() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine"; o.frequency.value = 880; g.gain.value = 0.0001;
    o.connect(g); g.connect(ctx.destination); o.start();
    const t = ctx.currentTime;
    g.gain.exponentialRampToValueAtTime(0.09, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
    o.stop(t + 0.4);
    const o2 = ctx.createOscillator();
    const g2 = ctx.createGain();
    o2.type = "sine"; o2.frequency.value = 1320; g2.gain.value = 0.0001;
    o2.connect(g2); g2.connect(ctx.destination); o2.start(t + 0.18);
    g2.gain.exponentialRampToValueAtTime(0.06, t + 0.2);
    g2.gain.exponentialRampToValueAtTime(0.0001, t + 0.55);
    o2.stop(t + 0.6);
  } catch (e) {
    // AudioContext unavailable or blocked by autoplay policy — non-critical
    console.warn("Beep failed:", e?.message || e);
  }
}

export function useLeadNotifier(leads) {
  const [unseen, setUnseen] = useState(0);
  const knownIds = useRef(new Set());
  const primed = useRef(false);

  useEffect(() => {
    if (!primed.current) {
      leads.forEach((l) => knownIds.current.add(l.id));
      primed.current = true;
      return;
    }
    const fresh = leads.filter((l) => !knownIds.current.has(l.id));
    if (fresh.length) {
      fresh.forEach((l) => knownIds.current.add(l.id));
      setUnseen((c) => c + fresh.length);
      beep();
      fresh.slice(0, 3).forEach((l) => {
        const hot = l.timeline === "Under 3 months";
        const firstName = (l.name || "").split(" ")[0] || "New lead";
        toast[hot ? "warning" : "info"](
          `${firstName} from ${l.target_country || "—"}${hot ? " · 🔥 Hot" : ""}`,
          {
            description: `${l.visa_type || ""} · ${l.timeline || ""}`,
            duration: 6000,
          }
        );
      });
    }
  }, [leads]);

  const clear = () => setUnseen(0);
  return { unseen, clear };
}
